const shape = {
  query_text: "string", // User's query
  response_text: "string", // ChatGPT's response
  recommended_lectures: [
    {
      lecture_id: "string", // Lecture ID from Elasticsearch
      lecture_title: "string", // Title of the recommended lecture
      score: "number", // Elasticsearch relevance score
      lecture_url: "string", // URL of the recommended lecture
      lecture_path: "string", // Path of the recommended lecture
    },
  ],
  user_id: "string", // ID of the user submitting the query
  timestamp: "timestamp", // Query submission time
  feedback: {
    liked: "boolean", // User liked the response
    disliked: "boolean", // User disliked the response
    comments: "string", // User comments on ChatGPT's answer
    lecture_feedback: [
      // Feedback on recommended lectures
      {
        lecture_id: "string", // Lecture ID
        liked: "boolean", // User liked the lecture
        disliked: "boolean", // User disliked the lecture
        comments: "string", // User comments
      },
    ],
  },
  metadata: {
    execution_time: "number", // Time taken to process the query
    chatgpt_prompt: "string", // Prompt sent to ChatGPT
    chatgpt_model: "string", // Model used for ChatGPT
    vector_query: "string", // Query sent to Elasticsearch
    elasticsearch_index: "string", // Index used for the search
  },
};

export function extractYouTubeId(url: string) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

export const parseLecturePath = (path: string) => {
  // Remove /cms_data/ prefix and split by '/'
  const parts = path.replace("/cms_data/", "").split("/");

  const result: Record<string, string> = {};

  // Process pairs of parts (key/value)
  while (parts.length > 0) {
    const key = parts.shift();

    if (key.match(/^class_\d+$/)) {
      result["grade"] = key;
    } else if (key) {
      const value = parts.shift();
      result[key] = value;
    }
  }
  return result;
};
